<template>
  <div
    :id="clickable ? buttonId : undefined"
    class="flex h-full flex-col overflow-hidden rounded-3xl border border-solid border-gray-500 bg-white transition-shadow"
    :class="[
      clickable && 'cursor-pointer hover:shadow-card hover:shadow-blue-400_a3',
      hasShadow && 'shadow-card',
      hasMinHeight && 'min-h-[400px]',
    ]"
    :title="clickable ? title : ''"
    @click="handleClick"
  >
    <div class="flex grow flex-col justify-between p-4 tablet:p-5">
      <div class="tablet:min-h-32">
        <h3 class="text-h5 mb-2 truncate">
          {{ title }}
        </h3>

        <p class="mb-4 line-clamp-3 text-sm leading-6 text-gray-700">
          {{ description }}
        </p>
      </div>

      <TheNuxtLink
        v-if="buttonName && buttonUrl"
        :id="!clickable ? buttonId : undefined"
        ref="linkRef"
        :to="buttonUrl"
        :title="!clickable ? buttonName : ''"
        :class="!clickable && 'hover:underline'"
        class="mt-auto inline-flex w-fit items-center truncate text-sm font-bold leading-6 text-blue-400 tablet:text-base"
      >
        {{ buttonName }}
      </TheNuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  import TheNuxtLink from '@/components/TheNuxtLink.vue';

  interface IProps {
    title: string;
    description: string;
    buttonId?: string;
    buttonUrl?: RouteLocationRaw;
    buttonName?: string;
    clickable?: boolean;
    hasShadow?: boolean;
    hasMinHeight?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    buttonId: undefined,
    buttonUrl: undefined,
    buttonName: undefined,
    clickable: false,
    hasShadow: true,
    hasMinHeight: true,
  });

  const linkRef = ref<InstanceType<typeof TheNuxtLink> | null>(null);

  const handleClick = (event: MouseEvent): void => {
    const linkEl = linkRef.value?.$el as HTMLElement | undefined;
    const isOutsideLink = linkEl && !linkEl.contains(event.target as Node);
    // 避免點擊連結本身時再次觸發，造成無窮迴圈
    if (props.clickable && props.buttonUrl && isOutsideLink) {
      linkEl.click();
    }
  };
</script>
